"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPTIMIZED_COHORT_RULES = void 0;
exports.OPTIMIZED_COHORT_RULES = {
// daysSinceLastPurchase: [],
// daysSinceLastBill: [],
};



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/cohort-rule/optimized-cohort-rule.js
// module id = 1252
// module chunks = 0